// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__ob6PJ","clinicsSelect":"TableHeading_clinicsSelect__12XUq"};